export default "__VITE_ASSET__C6Bs7nik__"